<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_vi"></a><a id="page_vii"></a>Contents</h1>
<h2 class="toc1a"><a href="#/xhtml/05_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc2"><a href="#/xhtml/06_Chapter1"><span class="tocpad"><span class="bold">Chapter 1</span></span> General Introduction</a></h2>
<h2 class="toc2"><a href="#/xhtml/07_Chapter2"><span class="tocpad"><span class="bold">Chapter 2</span></span> Warfare and Imperialism in Early Carthage</a></h2>
<h2 class="toc2"><a href="#/xhtml/08_Chapter3"><span class="tocpad"><span class="bold">Chapter 3</span></span> Armies Against Syracuse</a></h2>
<h2 class="toc2"><span href="#/xhtml/09_Chapter4" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 4</span></span> The Wars with Dionysius I of Syracuse</span></h2>
<h2 class="toc2"><span href="#/xhtml/10_Chapter5" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 5</span></span> Timoleon, Agathocles, and Pyrrhus</span></h2>
<h2 class="toc2"><span href="#/xhtml/12_Chapter6" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 6</span></span> The First War with Rome</span></h2>
<h2 class="toc2"><span href="#/xhtml/14_Chapter7" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 7</span></span> The Truceless War</span></h2>
<h2 class="toc2"><span href="#/xhtml/15_Chapter8" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 8</span></span> The Second War with Rome</span></h2>
<h2 class="toc2"><span href="#/xhtml/17_Chapter9" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 9</span></span> Killing a Phoenix: The End of Carthage</span></h2>
<h2 class="toc2"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 10</span></span> Punic Warfare: Conclusions</span></h2>
<h2 class="toc1"><span href="#/xhtml/19_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc1"><span href="#/xhtml/23_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?cc2ec62a